/* eslint-disable import/prefer-default-export */
export const DEFAULT_REFUND_OPTION_ORDER = ['GIFT_CARD', 'ORIGINAL_PAYMENT'];

export const REFUND_OPTION_TYPES = {
  ESTIMATE: 'ESTIMATE',
  STATIC: 'STATIC',
  NONE: 'NONE',
};
